import React from 'react';
const bonuses = [{
  title: 'Bibliothèque Professionnelle de Circuits Fonctionnels Senior™',
  description: "Des circuits fonctionnels prêts à utiliser pour travailler la force, l'équilibre, la mobilité, la coordination et la prévention des chutes, avec des variantes adaptées aux différents niveaux."
}, {
  title: 'Programme Annuel de Planification Senior™',
  description: 'Des calendriers, modèles et planifications professionnelles pour organiser facilement plusieurs mois de cours tout en conservant une progression cohérente.'
}, {
  title: "Système Professionnel d'Évaluation Continue™",
  description: "Des outils prêts à l'emploi pour réévaluer les participants, suivre leur évolution et conserver un historique clair de leurs progrès."
}, {
  title: "Bibliothèque d'Ateliers et Séances Thématiques™",
  description: "Une collection de séances spéciales et d'ateliers professionnels pour varier vos cours, maintenir la motivation et renouveler facilement votre programmation."
}, {
  title: "Banque de Variations Professionnelles d'Exercices™",
  description: 'Des variantes, progressions et adaptations prêtes à utiliser pour ajuster rapidement vos exercices selon les capacités de chaque participant.'
}];
const changes = [{
  emoji: '⚡',
  title: 'Gagnez des heures de préparation chaque semaine',
  description: 'Ne perdez plus votre temps à créer chaque séance depuis zéro. Ouvrez simplement le système, choisissez les ressources adaptées et commencez immédiatement votre cours.'
}, {
  emoji: '💪',
  title: 'Travaillez avec plus de confiance',
  description: "Structurez facilement vos séances grâce à des progressions claires, des outils professionnels et des supports prêts à l'emploi. Consacrez plus de temps à vos participants et moins à la préparation."
}, {
  emoji: '📈',
  title: 'Organisez des programmes plus efficaces',
  description: 'Utilisez des séances, des exercices et des planifications déjà structurés pour proposer des cours variés, cohérents et faciles à adapter à chaque groupe.'
}, {
  emoji: '🗂️',
  title: 'Organisez votre travail comme un professionnel',
  description: "Toutes vos ressources sont réunies dans un seul système. Moins de recherches. Moins d'improvisation. Plus d'organisation."
}];
export function BonusSection() {
  return <>
      <section className="py-6 px-4 sm:px-6 bg-navy text-white" data-id="element-15" data-mp="yd5nderkzmwj">
        <h2 className="text-2xl sm:text-4xl font-display text-center text-gold leading-none mb-2" data-id="element-16" data-mp="tevtd7hlesci">
          🎁 5 Bonus Premium Inclus
        </h2>
        <p className="text-center text-[12.5px] sm:text-sm text-cream/85 max-w-2xl mx-auto mb-4 leading-snug" data-id="element-17" data-mp="177294sgu2xbf">
          En plus de SENIOR FITNESS PRO™, vous recevrez 5 Bonus Premium conçus
          pour vous faire gagner encore plus de temps et enrichir votre travail
          au quotidien.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-18" data-mp="alid88ijgqgy">
          {bonuses.map((bonus, i) => <div key={bonus.title} className={`bg-navy-dark border border-gold/40 p-3.5 rounded-lg ${i === 4 ? 'sm:col-span-2' : ''}`} data-id="element-19" data-mp="5amtf1n3dt9p" data-mpi={i}>
              <p className="inline-block bg-gold/20 text-gold font-heading font-bold text-[10px] px-2 py-0.5 rounded mb-1.5 tracking-widest uppercase" data-id="element-20" data-mp="3rppcvegmc2cs">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-white mb-1 leading-tight" data-id="element-21" data-mp="o8z44rtnjb7e">
                {bonus.title}
              </h3>
              <p className="text-[12.5px] sm:text-sm text-cream/85 leading-snug" data-id="element-22" data-mp="9b6qk57o0wvu">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-23" data-mp="2u0dx2n8fme09">
        <h2 className="text-2xl sm:text-4xl font-display text-center text-navy leading-none mb-4" data-id="element-24" data-mp="2z1jq6m6083ab">
          Ce qui va changer pour vous
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-4xl mx-auto" data-id="element-25" data-mp="3f9hi90354n80">
          {changes.map(item => <div key={item.title} className="bg-white border-l-4 border-sage p-3.5 rounded-r-lg shadow-sm" data-id="element-26" data-mp="3aflmm4acncg0">
              <h3 className="text-[13px] sm:text-base font-heading font-bold text-navy mb-1 leading-snug" data-id="element-27" data-mp="30kbldirrz93a">
                <span aria-hidden="true" data-id="element-28" data-mp="20bspjgm5djb">{item.emoji}</span> {item.title}
              </h3>
              <p className="text-ink text-[12.5px] sm:text-sm leading-snug" data-id="element-29" data-mp="3t8ze1zeut0qv">
                {item.description}
              </p>
            </div>)}
        </div>
      </section>
    </>;
}